import Rollbar from 'rollbar/replay'
import type { App } from 'vue'
import { watch } from 'vue'

import { rollbarConfig } from '@/plugins/rollbarConfig'
import { useUserStore } from '@/stores/user'

const rollbar = new Rollbar(rollbarConfig)

export { rollbar }

function setRollbarPerson() {
  const userStore = useUserStore()
  const user = userStore.data
  if (user?.uuid) {
    rollbar.configure({
      payload: {
        person: {
          id: user.uuid,
          username: user.name || undefined,
          email: user.email || undefined,
        },
      },
    })
  } else {
    rollbar.configure({ payload: { person: undefined } })
  }
}

export default {
  install(app: App) {
    const env = import.meta.env.VITE_NODE_ENV

    setRollbarPerson()
    watch(() => useUserStore().data, setRollbarPerson, { deep: true })

    app.config.errorHandler = (error, vm, info) => {
      const reportToRollbar = env === 'production' || env === 'staging'
      if (reportToRollbar) {
        rollbar.error(error instanceof Error ? error : new Error(String(error)), {
          vue_component: vm?.$options?.name ?? 'anonymous',
          info,
        })
      } else {
        console.error(error)
      }
    }

    app.provide('rollbar', rollbar)
  },
}
